import React, { Component, Fragment } from 'react'
import Breadcrumb from '../../common/breadcrumb';
import Swal from "sweetalert2";
import { set_auth } from "../../../reducers/Auth";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Modal } from "antd";
import { HelpCircle } from "react-feather";
import "../../styling.css"
import { PERMISSIONS } from "../../../helper/permissionHelper";
import { withPageAccess } from "../../common/ProtectedPage";

export class PresensiSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: true,
            data: {},
            greet: '',
            quote: '',
            toleransi_keterlambatan: 0,
            showToleranceModal: false,
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    saveSettingMobile = () => {
        this.setState({
            loading: true,
        })
        let formToleransi = {
            toleransi_keterlambatan: this.state.toleransi_keterlambatan,
        }
        this.props.request("update_toleransi_setting", formToleransi, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.loadData()
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false,
                })
            });
    }

    loadData() {
        this.setState({
            loaded: false,
            loading: true
        })
        this.props.request("get_toleransi_setting", {}, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        loaded: true,
                        toleransi_keterlambatan: response.data,
                    })
                }
            })
        this.setState({
            loading: false
        })
    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Pengatura Presensi</title>
                    <meta name="description" content="Detail Presensi" />
                </Helmet>

                <Breadcrumb title="Pengaturan Presensi" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    {this.state.loaded ?
                                        <div className="mt-4">
                                            <label className="header-input-basic" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                Pengaturan Toleransi Keterlambatan
                                                <HelpCircle
                                                    size={18}
                                                    style={{ cursor: 'pointer', color: '#1890ff' }}
                                                    onClick={() => this.setState({ showToleranceModal: true })}
                                                />
                                            </label>
                                            <div className="row">
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="toleransi_keterlambatan"
                                                            id="toleransi0"
                                                            value="0"
                                                            checked={this.state.toleransi_keterlambatan === "0"}
                                                            onChange={() => this.setState({ toleransi_keterlambatan: "0" })}
                                                        />
                                                        <label className="form-check-label" htmlFor="toleransi0">
                                                            Nonaktifkan semua toleransi keterlambatan
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="toleransi_keterlambatan"
                                                            id="toleransi1"
                                                            value="1"
                                                            checked={this.state.toleransi_keterlambatan === "1"}
                                                            onChange={() => this.setState({ toleransi_keterlambatan: "1" })}
                                                        />
                                                        <label className="form-check-label" htmlFor="toleransi1">
                                                            Sesuaikan jam absensi menjadi waktu tetap
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="toleransi_keterlambatan"
                                                            id="toleransi2"
                                                            value="2"
                                                            checked={this.state.toleransi_keterlambatan === "2"}
                                                            onChange={() => this.setState({ toleransi_keterlambatan: "2" })}
                                                        />
                                                        <label className="form-check-label" htmlFor="toleransi2">
                                                            Anggap keterlambatan sebagai tidak ada
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                    }

                                    <div className="pull-right mt-4">
                                        {this.state.loading == false ?
                                            <button type="button" className="btn btn-primary" disabled={!this.state.loaded} onClick={() => { this.saveSettingMobile() }}>Simpan</button>
                                            :
                                            <button type="button" className="btn btn-primary"><i className="fa fa-refresh fa-spin" /> Loading</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    title="Apa itu Toleransi Keterlambatan?"
                    visible={this.state.showToleranceModal}
                    onCancel={() => this.setState({ showToleranceModal: false })}
                    footer={null}
                    width={420}
                >
                    <p style={{ marginBottom: 12 }}>
                        Toleransi keterlambatan adalah batas waktu tambahan yang diberikan kepada karyawan saat melakukan absensi masuk tanpa dianggap terlambat.
                    </p>
                    <div style={{ background: '#f6f8fa', borderRadius: 8, padding: '10px 14px' }}>
                        <strong>Pilihan yang tersedia:</strong>
                        <ul style={{ marginTop: 8, marginBottom: 0, paddingLeft: 18 }}>
                            <li><strong>Nonaktifkan</strong> — Tidak ada toleransi, semua keterlambatan dihitung.</li>
                            <li style={{ marginTop: 4 }}><strong>Sesuaikan jam absensi</strong> — Jam absensi disesuaikan menjadi waktu tetap.</li>
                            <li style={{ marginTop: 4 }}><strong>Anggap tidak ada</strong> — Keterlambatan diabaikan sepenuhnya.</li>
                        </ul>
                    </div>
                </Modal>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.Auth.auth,
    user: state.Auth.user,
    api_token: state.Auth.api_token,
})

const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(PresensiSetting, PERMISSIONS.PENGATURAN))
